import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";
import ai_welcome from "../../../images/Welcome_ai.png";

export default function StudyOneInstructionPageTwo(){
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>Many factors impact EAI! </h1>
                <Container style={{width:"90%"}}>
                    <Row>
                        <p>EmoAI captures more faces......</p>

                        <ul>
                            <li>Background</li>
                            <li>Head angle and obstructions</li>
                            <li>Gender</li>
                            <li>Age</li>
                        </ul>
                    </Row>
                    <p>What else?</p>

                    <Row>
                        <h1 className="subtitle">Could we make it better? </h1>
                        <p>Computer scientists believe that more diverse databases can reduce AI bias and improve performance.</p>
                    </Row>

                    <Row className="align-items-start mb-4">
                        <Col xs={5}>
                            <div className="chat-bubble-left">
                            Does this work for EAI?
                            </div>
                        </Col>
                        <Col xs={2} className="text-end">
                            <img
                                src={ai_thinking}
                                alt="FEAI icon"
                                style={{ width: "150px", height: "150px", }}
                            />
                        </Col>
                    </Row>
                   
                </Container>
            </Row>
        </Container>
    );
};